<div class="channel-product-mapping__wrapper">
  <div class="actions flex justify-content-end mb-4">
    <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
      Actions <i class="flaticon-more ml-2"></i>
    </button>
    <mat-menu class="lum-mat-menu" #menu="matMenu">
      <button
        mat-menu-item
        [routerLink]="['/tools/imports/app-integration-account-products']"
        [queryParams]="{
          appIntegrationAccountId:
            channel?.pullOrderIntegrationMapping?.appIntegrationAccountId,
        }"
      >
        <i class="fa fa-cloud-upload-alt mr-2 text-small"></i>
        Import Products
      </button>
      <button
        *ngIf="selectedRows.length > 0; else showPushAllOMSProducts"
        mat-menu-item
        [disabled]="pushUpdateLoading"
        (click)="onPushUpdates()"
      >
        <i
          class="fa fa-sync mr-2 text-small"
          [ngClass]="{ 'fa-spin': pushUpdateLoading }"
        ></i>
        Push Products ({{ selectedRows.length }})
      </button>
      <ng-template #showPushAllOMSProducts>
        <button
          [disabled]="pushUpdateLoading"
          (click)="onPushAllProducts()"
          mat-menu-item
        >
          <i
            class="fa fa-sync mr-2 text-small"
            [ngClass]="{ 'fa-spin': pushUpdateLoading }"
          ></i>
          Push All Product Stocks
        </button>

        <button
          [disabled]="syncLoading"
          (click)="
            hasChannel
              ? onSyncProductsByChannelPushStockOmsIds()
              : onOpenSyncProductsModal()
          "
          mat-menu-item
        >
          <i class="fas fa-cloud-download-alt mr-2 text-small"></i>
          Pull Products
        </button>

        <button *ngIf="channel?.id" (click)="onExportProduct()" mat-menu-item>
          <i class="fa fa-file-export mr-2 text-small"></i>
          Export Products
        </button>
      </ng-template>
    </mat-menu>
  </div>

  <!-- <div class="flex justify-end my-4 mr-4 gap-2 grow">
    <ng-container *ngIf="selectedRows.length > 0; else showPushAllOMSProducts">
      <button
        class="lum-button lum-button--secondary"
        [disabled]="pushUpdateLoading"
        (click)="onPushUpdates()"
      >
        <i
          class="fa fa-sync mr-2 text-small"
          [ngClass]="{ 'fa-spin': pushUpdateLoading }"
        ></i>
        Push Products ({{ selectedRows.length }})
      </button>
    </ng-container>

    <ng-template #showPushAllOMSProducts>
      <button
        class="lum-button lum-button--secondary"
        [disabled]="pushUpdateLoading"
        (click)="onPushAllProducts()"
      >
        <i
          class="fa fa-sync mr-2 text-small"
          [ngClass]="{ 'fa-spin': pushUpdateLoading }"
        ></i>
        Push All Product Stocks
      </button>
    </ng-template>

    <button
      class="lum-button"
      [disabled]="syncLoading"
      (click)="
        hasChannel
          ? onSyncProductsByChannelPushStockOmsIds()
          : onOpenSyncProductsModal()
      "
    >
      <i class="fas fa-cloud-download-alt mr-2 text-small"></i>
      Pull Products
    </button>
  </div> -->

  <lum-channel-product-mapping-unified
    [featureFlags]="featureFlags"
    [channel]="channel"
    (selectionChanged)="onSelectionChanged($event)"
  ></lum-channel-product-mapping-unified>
</div>
